import { useContext, useState } from "react";
import { EnrollData, FormProps } from "../../utils/types";
import { FormInput } from "./FormInput";
import * as R from "ramda";
import { UserContext } from "../../context/user-context/userContext";

export const UserInfoForm = (props: FormProps) => {
    // VARIABLES
    const { changeForm, formType, submitCallback } = props;

    // CONTEXT
    const userContext = useContext(UserContext);
    const { enroll, login } = userContext;

    // STATE
    const [data, setData] = useState<EnrollData>({
        email: "",
        password: "",
        firstname: "",
        lastname: ""
    });
    const [type, setType] = useState<"login" | "enroll">(formType);

    // FUNCTIONS
    const updateData = (text: string, input: "email" | "password" | "firstname" | "lastname") => {
        const newdata = R.clone(data);
        return setData({ ...newdata, [input]: text });
    };

    const switchForm = () => {
        if (type === "enroll") {
            setType("login");
        }
        if (type === "login") {
            setType("enroll");
        }
    };

    const submit = () => {
        if (type === "enroll") {
            enroll();
        }
        if (type === "login") {
            login();
        }

        if (!!submitCallback) {
            submitCallback();
        }
    };

    return (
        <form
            className="login-form"
            name="login-form"
            onSubmit={e => {
                e?.preventDefault();
                submit();
            }}
        >
            {type === "enroll" && (
                <>
                    <FormInput
                        error={false}
                        id="firstname"
                        type="text"
                        onChange={e => updateData(e.target.value, "firstname")}
                        value={data.firstname as string}
                        label="Firstname"
                        autofocus={false}
                        required={true}
                    />

                    <FormInput
                        error={false}
                        id="lastname"
                        type="text"
                        onChange={e => updateData(e.target.value, "lastname")}
                        value={data.lastname as string}
                        label="Lastname"
                        autofocus={false}
                        required={true}
                    />
                </>
            )}

            <FormInput
                error={false}
                id="email-input"
                type="email"
                onChange={e => updateData(e.target.value, "email")}
                value={data.email}
                label="Email"
                autofocus={false}
                required={true}
            />

            <FormInput
                error={false}
                id="password-input"
                type="password"
                onChange={e => updateData(e.target.value, "password")}
                value={data.password}
                label="Password"
                autofocus={false}
                required={true}
            />

            <div className="button-container">
                <input type="submit" value={type === "login" ? "Login" : "Enroll"} className="login-button" />

                {changeForm && (
                    <button className="enroll-button" onClick={() => switchForm()}>
                        {type === "enroll" && "Login"}
                        {type === "login" && "Enroll"}
                    </button>
                )}
            </div>
        </form>
    );
};
